export function initTransfer247MessageData(message) {
  return {
    message: message,
    isTransfer247MessageError: false
  }
}